import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import DevFormConfirmation from 'app/dev/DevFormConfirmation';
import { Box, Stack } from '@mui/material';

export default function DevComponent() {
    const [searchParams] = useSearchParams();
    const component = searchParams.get('c');

    let content: React.ReactNode = (
        <Stack>
            <Box>Components:</Box>
            <Box>
                <ul>
                    <li>
                        <Link to="/dev/component?c=form_confirmation">Form Confirmation</Link>
                    </li>
                </ul>
            </Box>
        </Stack>
    );

    if (component == 'form_confirmation') {
        content = <DevFormConfirmation />;
    }

    return (
        <Stack
            className={
                'default-components form-components-indent scroll-content-container scroll-content-container--form'
            }
            sx={{
                overflow: 'auto',
                flexGrow: 1,
                width: '100%',
                pt: 4,
                pb: 3,
                px: (theme) => theme.size.pxValue(theme.size.containerIndentX),
            }}
        >
            {content}
        </Stack>
    );
}
